import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-employee-details',
  templateUrl: './view-employee-details.component.html',
  styleUrls: ['./view-employee-details.component.css']
})
export class ViewEmployeeDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
